(function(){

G.Debug = G.Debug || {};

G.Debug.registerOutOfMemoryOnBitmapsReporter = registerOutOfMemoryOnBitmapsReporter;

return;

function registerOutOfMemoryOnBitmapsReporter() {
  G.Utils.wrapFunction(
    CanvasRenderingContext2D.prototype, 'getImageData',
    null, null,
    getImageDataProxy
  );

  return;

  function getImageDataProxy(originalFunc, sx, sy, sw, sh) {
    try {
      var restArgs = Array.prototype.slice.call(arguments, 1);
      return originalFunc.apply(this, restArgs);
    } catch(error) {
      if (isOutOfMemoryError(error)) {
        var BYTES_PER_PIXEL = 4;
        reportOutOfMemory('getImageData', sw * sh * BYTES_PER_PIXEL);
      }
      throw error;
    }
  }

  function isOutOfMemoryError(error) {
    return error instanceof RangeError;
  }

  function reportOutOfMemory(funcName, requestedMemory) {
    var memoryUsedByBitmaps = G.Debug.getMemoryUsedByBitmaps(game);
    G.Utils.SentryLog.logError(
      'Out of memory on ' + funcName,
      {
        tags: {
          memoryUsedByAssets:   bytesToKilobytes(memoryUsedByBitmaps.assets),
          memoryUsedByCanvases: bytesToKilobytes(memoryUsedByBitmaps.canvases),
          memoryUsedByBitmapsTotal: bytesToKilobytes(
            memoryUsedByBitmaps.assets +
            memoryUsedByBitmaps.canvases
          ),
          requestedMemory: bytesToKilobytes(requestedMemory)
        }
      }
    );
  }

  function bytesToKilobytes(bytes) {
    return bytes / 1024;
  }
}

}());
